import racing1 from "./img/cars/r1.jpg";
import racing2 from "./img/cars/r2.jpg";
import racing3 from "./img/cars/r3.jpg";
import racing4 from "./img/cars/r4.jpg";
import racing5 from "./img/cars/r5.jpg";
import racing6 from "./img/cars/r6.jpg";
import racing7 from "./img/cars/r7.jpg";

import racingt1 from "./img/cars/thumb/r1.jpg";
import racingt2 from "./img/cars/thumb/r2.jpg";
import racingt3 from "./img/cars/thumb/r3.jpg";
import racingt4 from "./img/cars/thumb/r4.jpg";
import racingt5 from "./img/cars/thumb/r5.jpg";
import racingt6 from "./img/cars/thumb/r6.jpg";
import racingt7 from "./img/cars/thumb/r7.jpg";

import toy1 from "./img/toys/t1.jpg";
import toy2 from "./img/toys/t2.jpg";
import toy3 from "./img/toys/t3.jpg";
import toy4 from "./img/toys/t4.jpg";
import toy5 from "./img/toys/t5.jpg";

import toyt1 from "./img/toys/thumb/t1.jpg";
import toyt2 from "./img/toys/thumb/t2.jpg";
import toyt3 from "./img/toys/thumb/t3.jpg";
import toyt4 from "./img/toys/thumb/t4.jpg";
import toyt5 from "./img/toys/thumb/t5.jpg";

import nature1 from "./img/nature/n1.jpg";
import nature2 from "./img/nature/n2.jpg";
import nature3 from "./img/nature/n3.jpg";

import naturet1 from "./img/nature/thumb/n1.jpg";
import naturet2 from "./img/nature/thumb/n2.jpg";
import naturet3 from "./img/nature/thumb/n3.jpg";

import product1 from "./img/product/p1.jpg";
import product2 from "./img/product/p2.jpg";
import product3 from "./img/product/p3.jpg";
import product4 from "./img/product/p4.jpg";
import product5 from "./img/product/p5.jpg";
import product6 from "./img/product/p6.jpg";

import productt1 from "./img/product/thumb/p1.jpg";
import productt2 from "./img/product/thumb/p2.jpg";
import productt3 from "./img/product/thumb/p3.jpg";
import productt4 from "./img/product/thumb/p4.jpg";
import productt5 from "./img/product/thumb/p5.jpg";
import productt6 from "./img/product/thumb/p6.jpg";

import architecture1 from "./img/Architecture/a1.jpg";
import architecture2 from "./img/Architecture/a2.jpg";
import architecture3 from "./img/Architecture/a3.jpg";
import architecture4 from "./img/Architecture/a4.jpg";
import architecture5 from "./img/Architecture/a5.jpg";

import architecturet1 from "./img/Architecture/thumb/a1.jpg";
import architecturet2 from "./img/Architecture/thumb/a2.jpg";
import architecturet3 from "./img/Architecture/thumb/a3.jpg";
import architecturet4 from "./img/Architecture/thumb/a4.jpg";
import architecturet5 from "./img/Architecture/thumb/a5.jpg";

import design1 from "./img/design/kk1.jpg"
import design2 from "./img/design/kk2.jpg"
import design3 from "./img/design/kk3.jpg"
import design4 from "./img/design/kk4.jpg"
import design5 from "./img/design/kk5.jpg"
import design6 from "./img/design/kk6.jpg"

import U1 from "./img/design/ss1.jpg"
import U2 from "./img/design/ss2.jpg"
import U3 from "./img/design/ss3.jpg"
import U4 from "./img/design/ss4.jpg"
import U5 from "./img/design/ss5.jpg"
import U6 from "./img/design/ss6.jpg"

import T1 from "./img/design/tf1.jpg"
import T2 from "./img/design/tf2.jpg"
import T3 from "./img/design/tf3.jpg"
import T4 from "./img/design/tf4.jpg"
import T5 from "./img/design/tf5.jpg"
import T6 from "./img/design/tf6.jpg"

import I1 from "./img/design/tr1.jpg"
import I2 from "./img/design/tr2.jpg"
import I3 from "./img/design/tr3.jpg"
import I4 from "./img/design/tr4.jpg"
import I5 from "./img/design/tr5.jpg"
import I6 from "./img/design/tr6.jpg"

import F1 from "./img/design/ws1.jpg"
import F2 from "./img/design/ws2.jpg"
import F3 from "./img/design/ws3.jpg"
import F4 from "./img/design/ws4.jpg"
import F5 from "./img/design/ws5.jpg"
import F6 from "./img/design/ws6.jpg"

import designt1 from "./img/design/thumb/kk1.jpg"
import designt2 from "./img/design/thumb/kk2.jpg"
import designt3 from "./img/design/thumb/kk3.jpg"
import designt4 from "./img/design/thumb/kk4.jpg"
import designt5 from "./img/design/thumb/kk5.jpg"
import designt6 from "./img/design/thumb/kk6.jpg"

import Ut1 from "./img/design/thumb/ss1.jpg" 
import Ut2 from "./img/design/thumb/ss2.jpg"
import Ut3 from "./img/design/thumb/ss3.jpg"
import Ut4 from "./img/design/thumb/ss4.jpg"
import Ut5 from "./img/design/thumb/ss5.jpg"
import Ut6 from "./img/design/thumb/ss6.jpg"

import Tt1 from "./img/design/thumb/tf1.jpg"
import Tt2 from "./img/design/thumb/tf2.jpg"
import Tt3 from "./img/design/thumb/tf3.jpg"
import Tt4 from "./img/design/thumb/tf4.jpg"
import Tt5 from "./img/design/thumb/tf5.jpg"
import Tt6 from "./img/design/thumb/tf6.jpg"

import It1 from "./img/design/thumb/tr1.jpg"
import It2 from "./img/design/thumb/tr2.jpg"
import It3 from "./img/design/thumb/tr3.jpg"
import It4 from "./img/design/thumb/tr4.jpg"
import It5 from "./img/design/thumb/tr5.jpg"
import It6 from "./img/design/thumb/tr6.jpg"

import Ft1 from "./img/design/thumb/ws1.jpg"
import Ft2 from "./img/design/thumb/ws2.jpg"
import Ft3 from "./img/design/thumb/ws3.jpg"
import Ft4 from "./img/design/thumb/ws4.jpg"
import Ft5 from "./img/design/thumb/ws5.jpg"
import Ft6 from "./img/design/thumb/ws6.jpg"






export const photographyData = [
  {
    category: "Racing",
    images: [
      { id: 1, thumb: racingt1, full: racing1, alt: "Race car on track" },
      { id: 2, thumb: racingt2, full: racing2, alt: "Pit stop" },
      { id: 3, thumb: racingt3, full: racing3, alt: "Speeding car" },
      { id: 4, thumb: racingt4, full: racing4, alt: "Crowd at race" },
      { id: 5, thumb: racingt5, full: racing5, alt: "Racing car close-up" },
      { id: 6, thumb: racingt6, full: racing6, alt: "Finish line" },
      { id: 7, thumb: racingt7, full: racing7, alt: "Trophy celebration" },
    ]
  },
  {
    category: "Toy Cars",
    images: [
      { id: 1, thumb: toyt1, full: toy1,  alt: "deloren" },
      { id: 2, thumb: toyt2, full: toy2, alt: "Classic toy car" },
      { id: 3, thumb: toyt3, full: toy3,  alt: "deloren" },
      { id: 4, thumb: toyt4, full: toy4, alt: "Classic toy car" },
      { id: 5, thumb: toyt5, full: toy5, alt: "Classic toy car" },
    ]
  },
  {
  category: "Nature",
    images: [
      { id: 1, thumb: naturet1, full: nature1, alt: "Sunset over mountains" },
      { id: 2, thumb: naturet2, full: nature2, alt: "Forest trail" },
      { id: 3, thumb: naturet3, full: nature3, alt: "Ocean view" },
    ]
  },
  {
  category: "Product",
    images: [
      { id: 1, thumb: productt1, full: product1, alt: "Sunset over mountains" },
      { id: 2, thumb: productt2, full: product1, alt: "Forest trail" },
      { id: 3, thumb: productt3, full: product3, alt: "Ocean view" },
      { id: 4, thumb: productt4, full: product4, alt: "Ocean view" },
      { id: 5, thumb: productt5, full: product5, alt: "Ocean view" },
      { id: 6, thumb: productt6, full: product6, alt: "Ocean view" },
    ]
  },
  {
  category: "Architecture",
    images: [
      { id: 1, thumb: architecturet1, full: architecture1, alt: "Sunset over mountains" },
      { id: 2, thumb: architecturet2, full: architecture2, alt: "Forest trail" },
      { id: 3, thumb: architecturet3, full: architecture3, alt: "Ocean view" },
      { id: 4, thumb: architecturet4, full: architecture4, alt: "Ocean view" },
      { id: 5, thumb: architecturet5, full: architecture5, alt: "Ocean view" },
    ]
  },
];

export const DesignData = [
  {
    category: "Knapsekêrel Vodka",
    description: "The brand Knapsekêrel is a vodka brand that is inspired by the idea of the distillation process and the refinement of vodka to its purest form. The visual concept behind Knapsekêrel is based on the idea of (Distilled for Distinction) that embodies the spirit of the brand. The adjectives for the company are Passion, Purity, Quality, Conficence, Diversity as well as Craftsmanship all leading to the design of the company. ",
    images: [
      { id: 1, thumb: designt1, full: design1, alt: "Logo 1"},
      { id: 2, thumb: designt2, full: design2, alt: "Logo: Colour, Black and White"},
      { id: 3, thumb: designt3, full: design3, alt: "Label Design"},
      { id: 4, thumb: designt4, full: design4, alt: "All 3 Label Designs"},
      { id: 5, thumb: designt5, full: design5, alt: "design 5Bottle with Glass"},
      { id: 6, thumb: designt6, full: design6, alt: "Special Edition flat design"},
    ]
  },
  {
    category: "Spijker Studios",
    description: "Is a self-promotional campaign, Spijkers Studios is a sports/events photography company that freezes intense moments in timne. The visual consept behind Spijker Studios is based on the idea of moments in movement/motion. The adjectives for the company are Passion, Innovation, Precision, Appreciation, Impact, Energy all leading to the photography of the company. ",
    images: [
      { id: 1, thumb: Ut1, full: U1, alt: "Logo 1"},
      { id: 2, thumb: Ut2, full: U2, alt: "Logo 2"},
      { id: 3, thumb: Ut3, full: U3, alt: "Logo 3"},
      { id: 4, thumb: Ut4, full: U4, alt: "Business Card Front"},
      { id: 5, thumb: Ut5, full: U5, alt: "Instagram post"},
      { id: 6, thumb: Ut6, full: U6, alt: "Full Identity Design"},
    ]
  },
  {
    category: "Tuffy Black Bags",
    description:"The marketing concept is based on the idea to show that a simple object such as plastic bottle can dream or aspire to be something else in this case the bottle are wearing the Tuffy Black Bags as the dream that they want to aspire to such as the knight, ninja, as well as the samurai. The characters that they want to aspire to is to show how tough the black bags of Tuffy are. Therefore the tagline of the concept being “The Tuffest’’, showing that the characters are tough and the black bags are tough.",
    images: [
      { id: 1, thumb: Tt1, full: T1, alt: "Knight"},
      { id: 2, thumb: Tt2, full: T2, alt: "Samuari"},
      { id: 3, thumb: Tt3, full: T3, alt: "Ninja"},
      { id: 4, thumb: Tt4, full: T4, alt: "Sidewalk Ad"},
      { id: 5, thumb: Tt5, full: T5, alt: "Instagram Post"},
      { id: 6, thumb: Tt6, full: T6, alt: "Magazine Ad"},
    ]
  },
  {
    category: "TREVO",
    description:"TREVO is a Independant Fitness Centre that focuses on the Evolution of Training, hence the name TREVO which is a combination of the words Training and Evolution. The visual concept behind TREVO is based on the idea of Coaching Development. The adjectives for the company are Passionate, Efficient, Safety, Informed and Focus all leading to the design of the company. The slogan of the company being (A better you) meaning that the trainging is focused on you as an individual",
    images: [
      { id: 1, thumb: It1, full: I1, alt: "Logo 1"},
      { id: 2, thumb: It2, full: I2, alt: "Logo 2"},
      { id: 3, thumb: It3, full: I3, alt: "Logo Application"},
      { id: 4, thumb: It4, full: I4, alt: "Instagram Post"},
      { id: 5, thumb: It5, full: I5, alt: "Magazine Design"},
      { id: 6, thumb: It6, full: I6, alt: "Brand Identity Design"},
    ]
  },
  {
    category: "WILD SPIRIT Outdoor gear and apparel",
    description:"Wild Spirit is an outdoor gear and apparel company that focuses on providing high-quality products for outdoor enthusiasts. The sloagan (Adventure is calling) represents the Passionate, Eager, Adventurous adjectives of the company. The visual concept was based on the idea of a silhouette of an animal making use of circles and straight lines to create the brand.",
    images: [
      { id: 1, thumb: Ft1, full: F1, alt: "Logo 1"},
      { id: 2, thumb: Ft2, full: F2, alt: "Business Card Mockup"},
      { id: 3, thumb: Ft3, full: F3, alt: "Letterhead Mockup"},
      { id: 4, thumb: Ft4, full: F4, alt: "Envelope flat design"},
      { id: 5, thumb: Ft5, full: F5, alt: "Shopping Bag flat design"},
      { id: 6, thumb: Ft6, full: F6, alt: "Identity Design"},
    ]
  },
];